import { ContentItem } from 'kentico-cloud-delivery';
import get from 'lodash/get';

export default class Enterprise extends ContentItem {
  constructor() {
    super({
      propertyResolver: fieldName => `_${fieldName}`
    });
  }

  get name() {
    return get(this, '_nazwa.value', '');
  }

  get enterpriseTypes() {
    const types = get(this, '_typ_inicjatywy___grupy.value', []);
    return types.map(t => t.codename);
  }

  get title() {
    return get(this, '_tytul.value', '');
  }

  get location() {
    return get(this, '_lokalizacja[0].value', '');
  }

  get logo() {
    return get(this, '_logo.value[0].url', '');
  }

  get facebookLink() {
    return get(this, '_link_facebook.value', '');
  }

  get website() {
    return get(this, '_strona_www.value', '');
  }

  get description() {
    return get(this, '_opis.value', '');
  }
}



// WEBPACK FOOTER //
// ./src/models/Enterprise.js